import type { AnchorTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const anchorDark: AnchorTheme = {
  name: 'Anchor',
  common: commonDark,
  self
}

export default anchorDark
